import { useState } from "react";
import { motion } from "framer-motion";
import { Trophy, RefreshCw } from "lucide-react";
import { Reveal, SectionTitle, Overline } from "@/components/Reveal";
import { genRanking } from "@/data/mock";

export const Ranking = () => {
  const [rows, setRows] = useState(() => genRanking());

  return (
    <section id="ranking" className="relative py-20 md:py-28" data-testid="ranking-section">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <Overline>Classificação</Overline>
            <SectionTitle className="mt-3">
              Top Sinais do <span className="text-gold-gradient">Momento</span>
            </SectionTitle>
          </div>
          <button
            onClick={() => setRows(genRanking())}
            className="self-start md:self-auto flex items-center gap-2 px-5 py-3 rounded-full bg-white/5 border border-white/10 text-white/80 hover:border-[#F5C542]/50 hover:text-white transition-colors duration-300 font-display text-sm"
            data-testid="ranking-refresh"
          >
            <RefreshCw className="w-4 h-4" /> Atualizar
          </button>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="glass-gold overflow-hidden">
            {/* Header */}
            <div className="hidden md:grid grid-cols-[60px_1.6fr_1.2fr_1fr_1fr_1.2fr] gap-4 px-6 py-4 border-b border-white/[0.08] text-[11px] uppercase tracking-wider text-white/40 font-display">
              <span>#</span>
              <span>Jogo</span>
              <span>Provedora</span>
              <span>Sinal</span>
              <span>Status</span>
              <span>Atualizado</span>
            </div>

            <div>
              {rows.map((r, i) => (
                <motion.div
                  key={r.id}
                  initial={{ opacity: 0, x: -12 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: i * 0.05 }}
                  className="grid grid-cols-2 md:grid-cols-[60px_1.6fr_1.2fr_1fr_1fr_1.2fr] gap-2 md:gap-4 px-5 md:px-6 py-4 items-center border-b border-white/[0.05] last:border-0 hover:bg-[#F5C542]/[0.03] transition-colors duration-300 group"
                  data-testid={`ranking-row-${r.id}`}
                >
                  <span className="font-display font-bold text-lg row-start-1">
                    {i < 3 ? (
                      <span className="inline-flex items-center gap-1 text-[#F5C542]">
                        <Trophy className="w-4 h-4" />
                        {i + 1}
                      </span>
                    ) : (
                      <span className="text-white/40">{i + 1}</span>
                    )}
                  </span>
                  <span className="font-display font-semibold text-white row-start-1 md:row-auto col-span-2 md:col-span-1 order-first md:order-none pl-2 md:pl-0">
                    {r.name}
                  </span>
                  <span className="text-white/55 text-sm">{r.provider}</span>
                  <span
                    className="font-display font-bold text-lg tracking-tight"
                    style={{ color: r.level.color }}
                  >
                    {r.rtp.toFixed(2)}%
                  </span>
                  <span>
                    <span
                      className="text-[10px] font-bold px-2.5 py-1 rounded-full border"
                      style={{
                        color: r.level.color,
                        borderColor: `${r.level.color}55`,
                        background: `${r.level.color}14`,
                      }}
                    >
                      {r.level.label}
                    </span>
                  </span>
                  <span className="text-white/40 text-xs">{r.updated}</span>
                </motion.div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
